import * as navigation from 'Navigation';

import RequestV2SubmissionFileState from './RequestV2SubmissionFileState';

export default class RequestV2SubmissionProgressAndOutputsTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Progress & Outputs',
      closeable: false,
      preferenceKey: navigation.PREFERENCE_KEY_IGNORE,
    };
  }

  getRequestV2SubmissionFileState(): RequestV2SubmissionFileState {
    return this.get('requestV2SubmissionFileState');
  }
}
